import React from 'react';
import styles from './styles';
import Image from 'next/image';

const PcModelSaleHighlights = ({ sale_highlights }) => {
  return (
    <div className='pc-model-sales-highlights-container'>
      <div className='pc-model-sales-highlights-image'>
        <Image src={sale_highlights.banner} width={427} height={100} />
      </div>
      <div className='pc-model-sales-highlights-list'>
        {sale_highlights.highlights.map((highlight, index) => (
          <div key={index} className='pc-model-sales-highlights-item'>
            <Image src={highlight.icon.url} width={21} height={21} />
            <span>{highlight.title}</span>
          </div>
        ))}
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};

export default PcModelSaleHighlights;
